/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import Discuss from 'parts/Discuss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Fade } from "react-awesome-reveal";
import Button from 'elements/Button';

// placeholder image - replace once you add an actual one

export default function EducationAndTrainingInstitutions() {
  return (
    <>

      {/* CHALLENGES SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold text-center mb-6">Challenges in Education Technology</h2>
          <p className="text-center text-gray-600 mb-10">Educational institutions rely on secure, reliable, and flexible IT systems to support students and staff.</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Digital Learning & Hybrid Classrooms</h3>
              <p className="text-gray-600">Support for virtual classes, digital content, LMS platforms, and device management.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Student Data Security</h3>
              <p className="text-gray-600">Protect sensitive records with encrypted systems, access control, and compliance readiness.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Campus Connectivity</h3>
              <p className="text-gray-600">High-speed and secure Wi‑Fi networks that support staff, students, and guest access.</p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="py-16">
        <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold mb-4">How We Support Educational Institutions</h2>
            <ul className="space-y-6 text-gray-600">
              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Reliable Hybrid Learning</p>
                  <p className="text-sm">Robust platforms and devices to support both in‑class and remote learning models.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Secure Campus Infrastructure</p>
                  <p className="text-sm">Threat monitoring, compliance tools, and secure device management for staff & students.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Improved Administrative Efficiency</p>
                  <p className="text-sm">Automated workflows, integrated platforms, and tech support to reduce downtime.</p>
                </div>
              </li>
            </ul>

            <div className="mt-6">
              <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Request an IT Assessment</Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6">
            <h3 className="text-xl font-semibold text-theme-blue mb-4">Typical Outcomes</h3>
            <div className="space-y-4 text-gray-600">
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Stronger digital learning experiences</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Improved data privacy compliance</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Reliable networks & devices</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Streamlined administration</strong></p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-16 bg-gradient-to-r from-light-theme-purple to-white">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-theme-blue font-bold">Ready to modernize your educational environment?</h2>
            <p className="text-gray-600 mt-2">We’ll help you create a safe, connected, and innovative place to learn.</p>
          </div>

          <div>
            <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Get Started</Button>
          </div>
        </div>
      </section>

      <Discuss />
    </>
  );
}
